import { createSlice } from "@reduxjs/toolkit";
import Amenities from "../../Pages/Amenities/Allamenities";

const initialState = {
  category: {
    page: 1,
    limit: 10,
    search: "",
    status: "",
  },

  subCategory: {
    page: 1,
    limit: 10,
    search: "",
    status: "",
  },

  waad: {
    page: 1,
    limit: 10,
    search: "",
    status: "",
  },
  // For Gaon
  gaon: {
    page: 1,
    limit: 10,
    search: "",
    status: "",
    waad_id: "",
  },

  selections: {
    page: 1,
    limit: 10,
    search: "",
    type: "",
    status: "",
    waad_id: "",
    sport_name: "",
    sport_level: "",
    job_type: "",
    job_department: "",
  },

  product: {
    page: 1,
    limit: 10,
    search: "",
    status: "",
  },
  state: {
    page: 1,
    limit: 10,
    search: "",
    status: "",
  },
  city: {
    page: 1,
    limit: 10,
    search: "",
    status: "",
  },
  faq: {
    page: 1,
    limit: 10,
    search: "",
    status: "",
  },
  Amenities: {
    page: 1,
    limit: 10,
    search: "",
    status: "",
  },
  Location: {
    page: 1,
    limit: 10,
    search: "",
    status: "",
  },
  Blog: {
    page: 1,
    limit: 10,
    search: "",
    status: "",
  },
  employment: {
    page: 1,
    limit: 10,
    search: "",
    status: "",
    category: "",
    type: "",
  },

  education: {
    page: 1,
    limit: 10,
    search: "",
    status: "",
    category: "",
    type: "",
  },
  building: {
    page: 1,
    limit: 10,
    search: "",
    type: "",
    status: "",
  },
  booking: {
    page: 1,
    limit: 10,
    search: "",
    status: "",
  },
  helpDesk: {
    page: 1,
    limit: 10,
    search: "",
    status: "",
  },
};

const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {

    // CATEGORY
    setCategoryFilters: (state, action) => {
      state.category = {
        ...state.category,
        ...action.payload,
      };
    },

    // SUB CATEGORY
    setSubCategoryFilters: (state, action) => {
      state.subCategory = {
        ...state.subCategory,
        ...action.payload,
      };
    },

    setEducationFilters: (state, action) => {
      state.education = {
        ...state.education,
        ...action.payload,
      };
    },
    setSelectionsFilters: (state, action) => {
      state.selections = {
        ...state.selections,
        ...action.payload,
      };
    },
    // ✅ WAAD FILTERS
    setWaadFilters: (state, action) => {
      state.waad = {
        ...state.waad,
        ...action.payload,
      };
    },

    // ✅ GAON FILTERS
    setGaonFilters: (state, action) => {
      state.gaon = {
        ...state.gaon,
        ...action.payload,
      };
    },

    // ✅ RESET WAAD FILTERS
    resetWaadFilters: (state) => {
      state.waad = {
        page: 1,
        limit: 10,
        search: "",
        status: "",
      };
    },

    // ✅ RESET GAON FILTERS
    resetGaonFilters: (state) => {
      state.gaon = {
        page: 1,
        limit: 10,
        search: "",
        status: "",
        waad_id: "",
      };
    },

    // PRODUCT
    setProductFilters: (state, action) => {
      state.product = {
        ...state.product,
        ...action.payload,
      };
    },
    setFaqFilters: (state, action) => {
      state.faq = {
        ...state.faq,
        ...action.payload,
      };
    },

    //state
    setState: (state, action) => {
      state.state = {
        ...state.state,
        ...action.payload
      }
    },
    // city
    setCity: (state, action) => {
      state.city = {
        ...state.city,
        ...action.payload
      }
    },
    setBlog: (state, action) => {
      state.Blog = {
        ...state.Blog,
        ...action.payload
      }
    },

    setAmenitiesFilters: (state, action) => {
      state.Amenities = {
        ...state.Amenities,
        ...action.payload
      }
    },
    setEmploymentFilters: (state, action) => {
      state.employment = {
        ...state.employment,
        ...action.payload,
      };
    },
    setBuildingFilters: (state, action) => {
      state.building = {
        ...state.building,
        ...action.payload,
      };
    },

    setBookingFilters: (state, action) => {
      state.booking = {
        ...state.booking,
        ...action.payload,
      };
    },
    // HELP DESK
    setHelpDeskFilters: (state, action) => {
      state.helpDesk = {
        ...state.helpDesk,
        ...action.payload
      }
    },
    setLocationFilters: (state, action) => {
      state.Location = {
        ...state.Location,
        ...action.payload
      }
    },
    resetCategory: (state) => {
      state.category = initialState.category;
    },
    resetCity: (state) => {
      state.city = initialState.city
    },
    resetState: (state) => {
      state.state = initialState.state
    },
    resetAmenities: (state) => {
      state.Amenities = initialState.Amenities
    },
    resetFaq: (state) => {
      state.faq = initialState.faq
    },
    resetBlog: (state) => {
      state.Blog = initialState.Blog
    },
    resetLocation: (state) => {
      state.Location = initialState.Location
    },
    resetSubCategory: (state) => {
      state.subCategory = initialState.subCategory;
    },

    resetProduct: (state) => {
      state.product = initialState.product;
    },

    // ✅ RESET HELP DESK
    resetHelpDesk: (state) => {
      state.helpDesk = initialState.helpDesk;
    },

    // ✅ RESET EMPLOYMENT
    resetEmployment: (state) => {
      state.employment = initialState.employment;
    },

    // ✅ RESET EDUCATION
    resetEducation: (state) => {
      state.education = initialState.education;
    },

    // ✅ RESET BUILDING
    resetBuilding: (state) => {
      state.building = initialState.building;
    },

    // ✅ RESET BOOKING
    resetBooking: (state) => {
      state.booking = initialState.booking;
    },
    resetSelectionsFilters: (state) => {
      state.selections = {
        page: 1,
        limit: 10,
        search: "",
        type: "",
        status: "",
        waad_id: "",
        sport_name: "",
        sport_level: "",
        job_type: "",
        job_department: "",
      };
    },
  },
});

export const {
  setCategoryFilters,
  setSubCategoryFilters,
  setProductFilters,
  resetCategory,
  resetSubCategory,
  resetProduct,
  setState,
  setCity,
  setAmenitiesFilters,
  setLocationFilters,
  setBlog,
  setFaq,
  // Help Desk
  setEducationFilters,
  setHelpDeskFilters,
  resetHelpDesk,
  setEmploymentFilters,
  resetEmployment,
  setBuildingFilters,
  setBookingFilters,
  // ✅ WAAD & GAON EXPORTS
  setWaadFilters,
  setGaonFilters,
  resetWaadFilters,    // ✅ ADDED
  resetGaonFilters,    // ✅ ADDED
  // Extra resets
  resetCity,
  resetState,
  resetAmenities,
  resetFaq,
  resetBlog,
  resetLocation,
  resetEducation,
  resetBuilding,
  resetBooking,
  setSelectionsFilters,
  resetSelectionsFilters,
} = filtersSlice.actions;

export default filtersSlice.reducer;